import script from "./VehicleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleCard.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleCard.vue?vue&type=style&index=0&id=c9493c9e&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9493c9e"]])

export default __exports__